import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { AppBar, Tabs, Toolbar, Tab } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShowChart from '@material-ui/icons/ShowChart';
import HomeIcon from '@material-ui/icons/Home';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../App';
import { LoginState } from './../../LoginState';

const useStyles = makeStyles({
  root: {
    height: '100%',
    // minWidth: '1440px',
    background: '#e6e6fa',
    color: '#000080',
    fontWeight: 'bold',
    marginTop: 5,
  },
});

const themeStyles = makeStyles({
  typography: {
    fontSize: 12,
    padding: '0px',
    margin: '0px',
  },
});

type ChangePage = {
  path: string;
  no: number;
};

type MenuProps = {
  lang: string;
};

type MenuInfo = {
  label: string;
  icon: string;
  url: string;
  groupUrls?: string[];
};

const MenuTab = () => {
  console.debug('MenuTab Update');
  const classes = useStyles();
  const classes2 = themeStyles();
  const [value, setValue] = React.useState(0);

  const { t, i18n } = useTranslation();
  const { login } = useContext(AppContext);
  const [menuList, setMenuList] = useState<MenuInfo[]>([]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  //レポート有効フラグ
  const reportButtonEnabled: boolean = login.GetSystemSettingModel.ReportButtonEnabled === 1 ? true : false;
  //オフライン判定有効フラグ
  const offLineJudgeButtonEnabled: boolean = login.GetSystemSettingModel.OffLineJudgeButtonEnabled === 1 ? true : false;
  //コナンエア画面有効フラグ
  const conanairEnabled: boolean = login.GetSystemSettingModel.ConanairEnabled === 1 ? true : false;
  //Emcb画面有効フラグ
  const emcbEnabled: boolean = login.GetSystemSettingModel.EmcbEnabled === 1 ? true : false;
  //部分放電画面有効フラグ
  const partialDischargeEnabled: boolean = login.GetSystemSettingModel.PartialDischargeEnabled === 1 ? true : false;

  const history = useHistory();

  useEffect(() => {
    //console.debug('MenuTab useEffect');
    const menuSrc: MenuInfo[] = [];

    if (!login.IsIoT) {
      menuSrc.push({
        label: t('MenuTab.ホーム', 'ホーム'),
        icon: 'Home.svg',
        url: '/Home',
      });
    } else {
      menuSrc.push({
        label: t('MenuTab.IoT機器一覧', 'ホーム'),
        icon: 'IoTDevList.svg',
        url: '/Home',
      });
    }
    menuSrc.push({
      label: t('MenuTab.傾向管理', '傾向管理'),
      icon: 'TrendGroup.svg',
      url: '/TrendGraphGroupSelectPage',
      groupUrls: ['/TrendGraphPage'],
    });
    if (!login.IsIoT) {
      menuSrc.push({
        label: t('MenuTab.リアルタイムトレンド', 'リアルタイムトレンド'),
        icon: 'RealTimeTrend.svg',
        url: '/RealTimeTrendGraphGroupSelectPage',
        groupUrls: ['/RealTimeTrendGraphPage'],
      });
    }
    menuSrc.push({
      label: t('MenuTab.電流診断', '電流診断'),
      icon: 'RawWaveforms.svg',
      url: '/PhaseCurrentGroupSelectPage',
      groupUrls: ['/PhaseCurrentPage'],
    });
    menuSrc.push({
      label: t('MenuTab.生波形比較', '生波形比較'),
      icon: 'Comparison.svg',
      url: '/RawWaveformComparisonGroupSelectPage',
      groupUrls: ['/RawWaveformComparisonPage'],
    });
    if (conanairEnabled) {
      menuSrc.push({
        label: t('MenuTab.生波形比較_コナン', '生波形比較（コナン）'),
        icon: 'Comparison.svg',
        url: '/RawWaveformComparisonConanairGroupSelectPage',
        groupUrls: ['/RawWaveformComparisonConanairPage'],
      });
    }
    menuSrc.push({
      label: t('MenuTab.FFT比較', 'FFT比較'),
      icon: 'Comparison.svg',
      url: '/FFTComparisonGroupSelectPage',
      groupUrls: ['/FFTComparisonPage'],
    });
    if (conanairEnabled) {
      menuSrc.push({
        label: t('MenuTab.FFT比較_コナン', 'FFT比較（コナン）'),
        icon: 'Comparison.svg',
        url: '/FFTComparisonConanairGroupSelectPage',
        groupUrls: ['/FFTComparisonConanairPage'],
      });
    }
    menuSrc.push({
      label: t('MenuTab.X-Y分布', 'X-Y分布'),
      icon: 'XYDiagram.svg',
      url: '/XYDiagramGroupSelectPage',
      groupUrls: ['/XYDiagramPage'],
    });
    if (emcbEnabled) {
      menuSrc.push({
        label: t('MenuTab.MCCトレースバック', 'MCCトレースバック'),
        icon: 'Comparison.svg',
        url: '/EMCTrendPage',
        groupUrls: ['/EMCTrendPage'],
      });
    }

    menuSrc.push({
      label: t('MenuTab.アラームサマリー', 'アラームサマリー'),
      icon: 'AlarmSummary.svg',
      url: '/AlarmSummaryPage',
    });
    menuSrc.push({
      label: t('MenuTab.アラーム履歴', 'アラーム履歴'),
      icon: 'AlarmHistory.svg',
      url: '/AlarmHistoryPage',
    });
    menuSrc.push({
      label: t('MenuTab.計測一覧', '計測一覧'),
      icon: 'ColView.svg',
      url: '/MeasureLogPage',
    });
    menuSrc.push({
      label: t('MenuTab.データ一覧', 'データ一覧'),
      icon: 'ColView.svg',
      url: '/FeatureParameterPage',
    });

    if (reportButtonEnabled) {
      menuSrc.push({
        label: t('MenuTab.レポート作成', 'レポート作成'),
        icon: 'Report.svg',
        url: '/ReportPage',
      });
    }
    if (offLineJudgeButtonEnabled) {
      menuSrc.push({
        label: t('MenuTab.オフライン判定', 'オフライン判定'),
        icon: 'ColView.svg',
        url: '/OffLineJudgePage',
      });
    }
    if (partialDischargeEnabled) {
      menuSrc.push({
        label: t('MenuTab.部分放電', '部分放電'),
        icon: 'Comparison.svg',
        url: '/PartialDischargePage',
      });
    }
    if (login.SET_AUTH) {
      menuSrc.push({
        label: t('MenuTab.設定', '設定'),
        icon: 'SystemSetting.svg',
        url: '/MeasureSettingsPage',
      });
    }
    menuSrc.push({
      label: t('MenuTab.グループ設定', 'グループ設定'),
      icon: 'ColView.svg',
      url: '/GroupSettingsPage',
    });
    if (login.SYSTEM_AUTH) {
      menuSrc.push({
        label: t('MenuTab.環境設定', '環境設定'),
        icon: 'CustomConfig.svg',
        url: '/CustomConfigPage',
      });
    }

    setMenuList(menuSrc);

    history.listen((location) => {
      console.log(`Change location: ${location.pathname}`);
      const toMenu = menuSrc.findIndex((mi) => mi.url === location.pathname);
      if (toMenu >= 0) {
        setValue(toMenu);
      } else {
        const toMenuSub = menuSrc.findIndex((mi) => {
          if (mi.groupUrls) {
            return mi.groupUrls.findIndex((gu) => gu === location.pathname) >= 0;
          } else {
            return false;
          }
        });
        if (toMenuSub >= 0) {
          setValue(toMenuSub);
        }
      }
    });
  }, [i18n.language]);

  return (
    <Paper className={classes.root}>
      <Tabs value={value} onChange={handleChange} variant="scrollable" aria-label="icon label tabs example">
        {menuList.map((mi, index) => {
          return (
            <Tab
              key={index}
              className={classes2.typography}
              label={mi.label}
              icon={<img width={40} height={40} src={`../icons/${mi.icon}`} />}
              component={Link}
              to={mi.url}
            />
          );
        })}
      </Tabs>
    </Paper>
  );
};

export default MenuTab;
